import React from 'react';
import { useSelector } from 'react-redux';
import colors from '../../utils/colors';

const ActivityStatus = ({value}) => {
  const { activityStatusById, language = {} } = useSelector(state => state.system)

  return <>{
    activityStatusById[value] ? (
      <span style={{color: colors.activity[value]}}>
        {activityStatusById[value].name[language.name]}
      </span>
    ) : value === 'upcoming' ? (
      <span style={{color: colors.orange}}>Upcoming</span>
    ) : value === 'ongoing' ? (
      <span style={{color: colors.green}}>Ongoing</span>
    ) : value === 'completed' ? (
      <span className="text-gray-999">Completed</span>
    ) : (
      <span className="text-gray-999">{String(value)}</span>
    )
  }</>
}

export { ActivityStatus }
